if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.items = this.querySelectorAll(".accordion__item");
      this.onlyOneActive = false;
      window.addEventListener('load', () => { 
        this.bindEvents();
      })
    }

    bindEvents() {    
      let t = this;
      this.items.forEach(function (item) {
        let toggle = item.querySelector(".accordion__toggle");
        if(toggle){
          toggle.addEventListener("click", function (event) {
            event.preventDefault();
            t.toggle(item.dataset.item);
          });
          if(item.dataset.open){
            t.toggle(item.dataset.item);
          }
        }

        let toggleNext = item.querySelector(".accordion__toggle-next");
        if(toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault(),
            t.toggle(parseInt(item.dataset.item) + 1);
          })
        }
      });
    }
        
    toggle(currentItem) {
      let t = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".accordion__content");
        if(!content) return;
        if(item.dataset.item == currentItem) {
          if(item.classList.contains('is-active')) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";                     
            if(content.querySelector(".lazyload")){
              setTimeout(function(){
                if(content.querySelector(".lazyload")){
                  const attrObserver = new MutationObserver((mutations) => {
                    mutations.forEach(mu => {
                      if (mu.type !== "attributes" && mu.attributeName !== "class") return;
                      console.log("class was modified!: ", mu);
                      content.style.maxHeight = content.scrollHeight + "px";
                    });
                  });                  
                  const pendingImages = content.querySelectorAll(".lazyload");
                  pendingImages.forEach(el => attrObserver.observe(el, {attributes: true}));
                }
              }, 1000);
            }
          }
          item.classList.toggle("is-active");
        } else if(t.onlyOneActive) {
          item.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define('accordion-wrapper', Accordion);
}